module.exports = __webpack_public_path__ + "img/helpIcon250px.24594a19.png";